import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';

export interface ReviewerCommentsDialogData {
  comments: string;
}

@Component({
  selector: 'app-reviewer-comments-dialog',
  imports: [CommonModule,
            MatDialogModule,
            MatButtonModule,
            TranslatePipe],
  templateUrl: './reviewer-comments-dialog.component.html',
  styleUrl: './reviewer-comments-dialog.component.scss',
})
export class ReviewerCommentsDialogComponent {
  constructor(private readonly dialogRef: MatDialogRef<ReviewerCommentsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ReviewerCommentsDialogData) {}

  close(): void {
    this.dialogRef.close();
  }
}
